export default __webpack_public_path__ + "static/media/me3.4cac0bc2.gif";